import React from "react";
import { Button, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class FileUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
      fileList: props.files ? JSON.parse(props.files) : [],
    };
    this.fileInputRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.files !== this.props.files && this.props.files) {
      try {
        const fileList = this.props.files ? JSON.parse(this.props.files) : [];
        this.setState({ fileList });
      } catch (error) {
        console.error("Errore nel parsing dei file:", error);
        this.setState({ fileList: [] });
      }
    }
  }

  handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    this.setState({ uploading: true });

    const newFiles = [];

    for (const file of files) {
      try {
        const base64 = await this.convertToBase64(file);
        newFiles.push({
          name: file.name,
          type: file.type,
          size: file.size,
          content: base64,
        });
      } catch (error) {
        console.error("Errore nella conversione del file:", error);
      }
    }

    const updatedList = [...this.state.fileList, ...newFiles];
    this.setState({
      fileList: updatedList,
      uploading: false,
    });

    this.props.onChange(JSON.stringify(updatedList));
  };

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // Rimuovi il prefisso "data:application/pdf;base64," per risparmiare spazio
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  handleDelete = (index) => {
    const newFileList = [...this.state.fileList];
    newFileList.splice(index, 1);
    this.setState({ fileList: newFileList });
    this.props.onChange(JSON.stringify(newFileList));
  };

  handlePreview = (file) => {
    // Crea un blob URL per il file
    const byteCharacters = atob(file.content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: file.type });

    const blobUrl = URL.createObjectURL(blob);

    // Apri in una nuova finestra o scarica
    window.open(blobUrl, "_blank");
  };

  handleDownload = (file) => {
    // Crea un blob URL per il file e forza il download
    const byteCharacters = atob(file.content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: file.type });

    const blobUrl = URL.createObjectURL(blob);

    // Crea un link per il download
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const { fileList, uploading } = this.state;

    return (
      <div style={{ marginBottom: "20px" }}>
        <input
          type="file"
          multiple
          onChange={this.handleFileChange}
          style={{ display: "none" }}
          ref={this.fileInputRef}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={() => this.fileInputRef.current.click()}
          disabled={uploading}
          style={{ marginBottom: "10px" }}
        >
          {uploading ? "Caricamento in corso..." : "Carica File"}
          {uploading && (
            <CircularProgress size={24} style={{ marginLeft: 8 }} />
          )}
        </Button>

        {fileList.length > 0 && (
          <div>
            <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
              File caricati:
            </div>
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "4px",
                padding: "10px",
              }}
            >
              {fileList.map((file, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    {file.name}{" "}
                    {file.size && `(${(file.size / 1024).toFixed(1)} KB)`}
                  </div>
                  <div>
                    <IconButton
                      size="small"
                      onClick={() => this.handlePreview(file)}
                      title="Visualizza"
                    >
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => this.handleDownload(file)}
                      title="Scarica"
                    >
                      <GetAppIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => this.handleDelete(index)}
                      title="Elimina"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}
